import { TIER } from '@nx/state';
import type { Instance, InstanceSize, Project, TierConfig } from '@nx/state';

import { isPAYG } from '../entities/helpers';
import { AdditionalSettingsSection, CspSection, DetailsSection, GraphAnalyticsSection } from '../form-components';
import { SizeSection } from '../form-components/size-section';
import type { InstanceConfigureFormData } from './form-data';

type NewConfigureInstanceProps = {
  data: InstanceConfigureFormData;
  onChange: (data: Partial<InstanceConfigureFormData>) => void;
  instance: Instance;
  project: Project;
  tierConfig: TierConfig;
  // Optional because sometimes we are a unicorn that doesn't
  // match a regular size
  initialSize?: InstanceSize;
  sizes: InstanceSize[];
};

export const NewConfigureInstanceForm = ({
  data,
  onChange,
  instance,
  project,
  initialSize,
  sizes,
  tierConfig,
}: NewConfigureInstanceProps) => {
  const handleSizeChange = (size: InstanceSize) => {
    onChange({ size });
  };

  if (!instance.availableActions.resize.enabled) {
    return <p>Resizing unavailable: {instance.availableActions.resize.message}</p>;
  }

  return (
    <div className="@container flex flex-col gap-4">
      <DetailsSection data={data} onDataChange={onChange} validation={null} />
      {data.tier !== TIER.FREE && (
        <>
          <CspSection
            data={data}
            onDataChange={onChange}
            validation={null}
            project={project}
            instance={instance}
            tierConfig={tierConfig}
          />
          <SizeSection
            project={project}
            data={data}
            options={sizes}
            initialSize={initialSize}
            onDataChange={handleSizeChange}
            hidePricing={!isPAYG(data.tier, project.billingMethod)}
          />
          {data.tier === TIER.PROFESSIONAL && <GraphAnalyticsSection data={data} onDataChange={onChange} />}
          <AdditionalSettingsSection data={data} onDataChange={onChange} project={project} instance={instance} />
        </>
      )}
    </div>
  );
};
